import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容栏目",
    links: [
      { label: "明星八卦", path: "/gossip" },
      { label: "明星黑料", path: "/black" },
      { label: "娱乐新闻", path: "/news" },
      { label: "站内搜索", path: "/search" },
    ],
  },
  {
    title: "关于站点",
    links: [
      { label: "关于我们", path: "/about" },
      { label: "联系反馈", path: "/contact" },
      { label: "版权声明", path: "/about#copyright" },
      { label: "免责声明", path: "/about#disclaimer" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-background-200 mt-12">
      <div className="px-4 md:px-6 py-10 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center gap-2.5 cursor-pointer">
              <span className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center">
                <i className="ri-fire-line text-primary-950 text-xl" />
              </span>
              <span className="font-heading text-xl font-black text-background-50">黑料吃瓜</span>
            </Link>
            <p className="text-sm text-background-300/90 leading-7 mt-4 max-w-md">
              专注娱乐八卦与明星黑料的资讯平台，用时间线、公开资料与多方回应还原事件全貌。站内内容为演示用途，人物与事件均为虚构。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-wechat-fill", "ri-weibo-fill", "ri-article-line", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center text-background-100"
                >
                  <i className={`${icon} text-base`} />
                </span>
              ))}
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h4 className="text-sm font-semibold text-background-50 tracking-wide mb-3">{column.title}</h4>
              <ul className="space-y-2">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-300/85 hover:text-accent-300 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-9 pt-5 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-background-300/70">
          <p>© 2026 黑料吃瓜 · 本站内容均为虚构演示，与任何真实人物无关。</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line" />
            拒绝造谣，理性吃瓜
          </p>
        </div>
      </div>
    </footer>
  );
}